export default __webpack_public_path__ + "static/media/chevron-right.f4884e73.svg";